import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {PortTheme} from "~/ui/theme";
import {Typography} from "@mui/material";
import {TypographyProps} from "@mui/system";


export type TagProps = TypographyProps & {
    endIcon?: any
    disabled?: boolean
    children?: any
}


const useStyles = makeStyles<PortTheme, TagProps>(theme => ({
    root: {
        backgroundColor: props => props.disabled ? theme.palette.action.disabledBackground : "rgba(63, 121, 181, 0.12)",
        color: props => props.disabled ? theme.palette.action.disabled : theme.palette.primary.main,
        borderRadius: 8,
        padding: "0px 8px",
        height: 20,
        display: "inline-flex",
        alignItems: "center"
    },
    icon: {
        marginLeft: 6,
        display: "flex",
        alignItems: "center",
        "& > .MuiSvgIcon-root": {
            color: props => props.disabled ? theme.palette.action.disabled : "#3F79B5",
            fontSize: "12px",
        }
    }
}));


export const Tag = (props: TagProps) => {
    const {children, endIcon, disabled, ...other} = props;
    const classes = useStyles(props);

    return (
        <div className={classes.root}>
            <Typography variant="tagsText" color="inherit" {...other}>
                {children}
            </Typography>
            {endIcon && (
                <div className={classes.icon}>
                    {endIcon}
                </div>
            )}
        </div>
    )
}